// secondaryInsurance.js — U2-INS C4 (TEST 3.07): what the secondary card saves, and how.
// Explicit .js imports of import-free modules, so scripts/check-discovery-triggers.mjs (and the
// cross-repo probe) import it in node as it is.
//
// ★★★ TWO ROUTES WRITE insurance.secondary, AND ONE OF THEM CLEARS IT.
//   * POST /users/<id>/secondary-insurance (rcm_service.set_secondary_insurance) stores the
//     object as sent — but a body with NO member ID takes its CLEAR path: it deletes
//     insurance.secondary AND insurance.last_eligibility_secondary (INSURE-2's trap). So
//     secondaryPayload() is null without a member ID, and nothing may post it.
//   * PUT /profile shallow-merges the insurance section: `secondary` is replaced as a unit and
//     every sibling key (last_eligibility_secondary, the primary's keys) is kept. A Search with no
//     member ID yet saves the policyholder this way, merged onto the stored secondary so a
//     member ID already on file is kept: secondaryPolicyholderBody().
//   The secondary search (discover_insurance target 'secondary') reads the SAVED
//   insurance.secondary.subscriberRelationship and policyholder fields, by the primary's rules.
import { slimCard } from './slimCard.js'
import { policyholderFields } from './discoverySearch.js'

const trim = (v) => String(v ?? '').trim()

// The secondary as the save route stores it, or null when there is no member ID.
export function secondaryPayload({ carrier, memberId, groupNumber, policyholder, cardFront, cardBack } = {}) {
  const m = trim(memberId)
  if (!m) return null
  const out = { provider: trim(carrier?.name), memberId: m }
  if (trim(carrier?.payerId)) out.payerId = trim(carrier.payerId)
  if (trim(groupNumber)) out.groupNumber = trim(groupNumber)
  Object.assign(out, policyholderFields(policyholder))
  const f = slimCard(cardFront); const b = slimCard(cardBack)
  if (f) out.cardFront = f
  if (b) out.cardBack = b
  return out
}

// The insurance section for PUT /profile when the secondary has no member ID yet: the stored
// secondary (if any) with the policyholder's four keys over it. Never a key outside `secondary`.
export function secondaryPolicyholderBody(storedSecondary, policyholder) {
  const base = storedSecondary && typeof storedSecondary === 'object' ? storedSecondary : {}
  return { secondary: { ...base, ...policyholderFields(policyholder) } }
}

// The fields a scan of the secondary card fills (useCardScanPair's merged OCR; TEST 1.01's
// back-of-card payer rule is the hook's, inherited as it is).
export function secondaryFromScan(merged, prev = {}) {
  const x = merged || {}
  const name = trim(x.provider || x.payerName || x.insurerName)
  const payerId = trim(x.stediPayerId || x.primaryPayerId || x.payerId)
  return {
    carrier: name ? { name, payerId } : (prev.carrier || { name: '', payerId: '' }),
    memberId: trim(x.memberId) || prev.memberId || '',
    groupNumber: trim(x.groupNumber) || prev.groupNumber || '',
  }
}
